import { render } from "./exhibitions-list-modal.vue?vue&type=template&id=82735354"
import script from "./exhibitions-list-modal.vue?vue&type=script&lang=js"
export * from "./exhibitions-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__